export const transform = (raw: any) => {
  return {
    ...raw,
  };
};
